import React from 'react';
import PropTypes from 'prop-types';

import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ListingPhotos.css';
import { Button, Carousel } from 'react-bootstrap';
import cx from 'classnames';
import FontAwesome from 'react-icons/fa';
import { Flex } from 'rebass';
import { buildPhotoPath } from './../../../helpers/photoutils';

class ListingPhotos extends React.Component {
  static propTypes = {
    id: PropTypes.number,
    listPhotos: PropTypes.array,
    coverPhoto: PropTypes.number,
    size: PropTypes.string,
  };

  static defaultProps = {
    listPhotos: [],
    coverPhoto: 0,
    size: 'x_medium',
  };

  render() {
    const { id, listPhotos, coverPhoto, size } = this.props;

    return (
      <div className={s.listPhotoContainer}>
        <Carousel
          nextIcon={
            <Flex
              style={{
                height: '100%',
              }}
              alignItems="center"
              justifyContent="center"
            >
              <i className=" fal fa-angle-right" />
            </Flex>
          }
          prevIcon={
            <Flex
              style={{
                height: '100%',
              }}
              alignItems="center"
              justifyContent="center"
            >
              <i className="fal fa-angle-left" />
            </Flex>
          }
          indicators={false}
          interval={0}
          wrap={false}
          className={cx('row')}
        >
          {listPhotos != null &&
            listPhotos.length &&
            listPhotos.map((item, itemIndex) => (
              <Carousel.Item key={itemIndex}>
                <div className={cx('col-md-12 col-sm-12 col-xs-12')}>
                  <a href={`/details/${id}`}>
                    <div className={s.parent}>
                      <div className={cx(s.children)}>
                        <div className={s.content}>
                          <div
                            className={cx(s.imageContent)}
                            style={{
                              backgroundImage: `url(${buildPhotoPath(
                                size,
                                item.name,
                              )})`,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </Carousel.Item>
            ))}
        </Carousel>
      </div>
    );
  }
}

export default withStyles(s)(ListingPhotos);



// WEBPACK FOOTER //
// ./src/components/SearchListing/ListingPhotos/ListingPhotos.js